import React, { useState } from "react";

const VehiclePagecard3 = (props) => {
  const [enabled, setEnabled] = useState(false);
  // console.log("Props")
  // Choose heading & description based on toggle state
  const headingToShow = enabled ? props.heading1 : props.heading;
  const descriptionToShow = enabled ? props.des1 : props.des;

  return (
    <div className=" w-96 md:w-full  border rounded overflow-hidden mt-2">
      {/* Header with toggle */}
      <div className="bg-[#2374BF]   text-white pl-1 p-1 text-md flex justify-between font-semibold">
        <div>{headingToShow}</div>
        <div>
          <button
            onClick={() => setEnabled(!enabled)}
            title={!enabled ? props.heading1 : props.heading} // <-- tooltip on hover
            className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-300 ${enabled ? "bg-gray-400" : "bg-gray-300"
              }`}
          >
            <span
              className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-300 ${enabled ? "translate-x-6" : "translate-x-1"
                }`}
            />
          </button>
        </div>
      </div>

      {/* Always show vcards */}
      {props.vcards}

      {/* Show the correct description based on toggle */}
      <div className="px-4 py-2">{descriptionToShow}</div>
    </div>
  );
};

export default VehiclePagecard3;
